const HomeIcon = () => {
  return (
    <svg viewBox="0 0 20.336 20.336">
      <g transform="translate(-47.367 -31.578)">
        <path
          d="M57.536,31.578a.845.845,0,0,0-.593.242L47.7,39.38c-.01.007-.02.017-.03.023l-.03.026v0a.845.845,0,0,0,.576,1.466h.848V50.22a1.694,1.694,0,0,0,1.695,1.695H64.314a1.694,1.694,0,0,0,1.695-1.695V40.9h.847a.85.85,0,0,0,.579-1.47l-.013-.01c-.02-.016-.04-.03-.06-.046l-3.049-2.492V33.273a.849.849,0,0,0-.847-.847h-.847a.849.849,0,0,0-.847.847V34.8l-3.664-3A.853.853,0,0,0,57.536,31.578ZM54.993,43.441h5.084V50.22H54.993Z"
          transform="translate(0 0)"
        />
      </g>
    </svg>
  );
};

export default HomeIcon;
